import {domainIncidentAPI} from 'features/domain/api/domainIncidentAPI';
import {useSearchHandler} from 'shared/lib/hooks/useSearchParamsHandler';

export const useDomainIncidentHeader = () => {
    const {currentValue, onSearchSubmit} = useSearchHandler('domain');
    const {data, isLoading, error, refetch} = domainIncidentAPI.useGetSummaryDomainIncidentQuery();

    return {
        search: currentValue,
        onSearchSubmit,
        summary: data,
        isSummaryLoading: isLoading,
        isSummaryError: !!error,
        refetchSummary: refetch,
    };
};

export default useDomainIncidentHeader;
